// extracted by mini-css-extract-plugin
export default {"root":"WhyUs_root__c5c1T","link":"WhyUs_link__bTjZz"};